<ng-container *transloco="let t">
  <h1>{{ t('Error 404') }}</h1>
  <img src="/assets/not-found/error-image.jpg" alt="" width="607" height="276" />
  <p>
    {{ t('The page you requested was not found.') }}
  </p>
  <p>
    {{ t('Make sure the address you entered is correct or go to the home page.') }}
  </p>
  <button app-button [routerLink]="'/' | addLocale">{{ t('Home page') }}</button>
</ng-container>
